<template>
  <div
    class="
      candidate-log
      huntica-nice-scroll
      d-flex flex-column justify-end
      fill-height overflow-y-hidden
    "
  >
    <VSheet class="elevation-5 mt-n3" width="100%" height="5" />
    <div
      ref="messagesContainer"
      class="messages-container pa-2 pa-md-5 flex-grow-1 overflow-y-auto huntica-nice-scroll"
    >
      <VAlert v-if="!logs.length" type="info">
        {{ $t('empty') }}
      </VAlert>
      <CandidateLogMessages
        v-else
        :vacancy="vacancy" :messages="logs" :candidate="candidate"
        :show-review="showReview"
        @show-interview="$emit('show-interview', $event)"
        @change-active-tab="$emit('change-active-tab', $event)"
      />
    </div>
  </div>
</template>

<script>
import compareDatesAsc from 'date-fns/compareAsc';
import CandidateLogMessages from './CandidateLogMessages.vue';
import { safeGet } from '../../functions';
import { logType } from '../../enums';

export default {
  name: 'CandidateLog',
  components: {
    CandidateLogMessages,
  },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    showReview: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    logs() {
      return [
        ...this.candidateLogs,
        ...this.onlineInterviewLogs,
        ...this.officeInterviewLogs,
      ].sort((a, b) => compareDatesAsc(new Date(a.createdAt), new Date(b.createdAt)));
    },
    candidateLogs() {
      return this.candidate.logs.map(l => ({ ...l, type: logType.CANDIDATE }));
    },
    onlineInterviewLogs() {
      return safeGet(this.candidate, ['interview', 'logs'], [])
        .map(l => ({ ...l, type: logType.ONLINE_INTERVIEW, eventType: logType.ONLINE_INTERVIEW }));
    },
    officeInterviewLogs() {
      return safeGet(this.candidate, ['officeInterview', 'logs'], [])
        .map(l => ({ ...l, type: logType.OFFICE_INTERVIEW, eventType: logType.OFFICE_INTERVIEW }));
    },
  },
  watch: {
    logs() {
      this.$nextTick(this.scrollToBottom);
    },
  },
  methods: {
    scrollToBottom() {
      if (this.$refs.messagesContainer) {
        const el = this.$refs.messagesContainer;
        el.scrollTop = el.scrollHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .messages-container {
    width: 100%;
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      height: 0px;
    }
  }
</style>

<i18n locale="en" lang="yaml">
  empty: The log is empty
  leaveComment: Leave a comment
  goBack: Go back
</i18n>

<i18n locale="ru" lang="yaml">
  empty: Пусто
  leaveComment: Оставить комментарий
  goBack: Назад
</i18n>
